var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_56919_46288",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#070038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20M40 20M40 20M0 20M20 0M40 20M20 40M0 20M20 40V38C10.0589 38 2 29.9411 2 20H0H-2C-2 32.1503 7.84974 42 20 42V40ZM40 20H38C38 29.9411 29.9411 38 20 38V40V42C32.1503 42 42 32.1503 42 20H40ZM20 0V2C29.9411 2 38 10.0589 38 20H40H42C42 7.84974 32.1503 -2 20 -2V0ZM20 0V-2C7.84974 -2 -2 7.84974 -2 20H0H2C2 10.0589 10.0589 2 20 2V0Z",
    fill: "#00E387",
    mask: "url(#path-1-inside-1_56919_46288)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2901 14.744C17.2901 13.712 17.5301 12.938 18.0101 12.422C18.4901 11.894 19.1441 11.63 19.9721 11.63C20.8361 11.63 21.5081 11.906 21.9881 12.458C22.4801 13.01 22.7261 13.844 22.7261 14.96V16.292C22.7261 16.676 22.6781 17.018 22.5821 17.318C22.4981 17.618 22.3841 17.894 22.2401 18.146C22.0961 18.398 21.9281 18.626 21.7361 18.83C21.5561 19.034 21.3701 19.226 21.1781 19.406C20.9981 19.574 20.8181 19.748 20.6381 19.928C20.4581 20.096 20.2961 20.288 20.1521 20.504C20.0081 20.72 19.8941 20.966 19.8101 21.242C19.7261 21.506 19.6841 21.812 19.6841 22.16V22.574H22.7261V24.5H17.2721V22.286C17.2721 21.71 17.3261 21.212 17.4341 20.792C17.5541 20.36 17.7041 19.988 17.8841 19.676C18.0641 19.352 18.2621 19.076 18.4781 18.848C18.6941 18.608 18.9041 18.386 19.1081 18.182C19.4321 17.87 19.7141 17.546 19.9541 17.21C20.1941 16.874 20.3141 16.496 20.3141 16.076V14.258C20.3141 14.006 20.2841 13.826 20.2241 13.718C20.1761 13.61 20.0981 13.556 19.9901 13.556C19.8821 13.556 19.8041 13.598 19.7561 13.682C19.7201 13.766 19.7021 13.928 19.7021 14.168V16.598H17.2901V14.744Z",
    fill: "#00E387"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.b8f058eb9d27a2092c7625c03fc71b93.svg";
export { ForwardRef as ReactComponent };